
export default {
  middleware: 'checkCart',
  head: {
    title: 'Compra-pedido',
  },
}
